
































import { Component, Prop, Vue } from 'vue-property-decorator';
import date from '@/mixins/date';
@Component({
    filters: {
  date
}
})
export default class InvoiceViewerHeader extends Vue {
    @Prop() dateCreated: Date;
    @Prop() invoiceId: number;
}
